<div [loading]="loading">
	<gob-header></gob-header>
	<div class="block form-admin">
		<gob-step-order [ind]="1"></gob-step-order>
		<div class="back-container">
			<gob-back [url]="route.get('cart')"></gob-back>
		</div>
		<h2 class="admin">Je sélectionne mon mode de livraison</h2>
    <div>
      <div class="table-responsive shipping">
        <table class="table table-borderless">
          <caption>Pour les retraits boutique, assurez-vous d'avoir reçu l'e-mail de mise à disposition de votre commande avant de vous déplacer</caption>
          <thead>
            <tr>
              <th colspan="5">
                {{getAvailability() === 0 ? 'Les produits dans votre panier sont tous en stock, votre commande sera délivrée intégralement' :
                getAvailability() === 1 ? 'Votre panier contient un produit en précommande, votre commande sera disponible à partir de sa date de sortie' :
                'Votre panier contient plusieurs produits en précommande, votre commande sera disponible à partir de sa date de sortie'}}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let shipper of shippers">
              <tr>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="img-container me-2">
                      <img src="assets/img/icons/Colissimo_Logo_Q_CS3.png" title="Colissimo" class="shipper-img"/>
                    </div>
                    <div>
                      <p>{{shipper.name}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="shipper">
                  <div class="form-check">
                    <input (change)="setRelay()" class="form-check-input" type="radio" name="shipper" id="shipper-{{shipper.ident}}" value="{{shipper.ident}}" [(ngModel)]="order.shipper">
                    <label class="form-check-label" for="shipper-{{shipper.ident}}">
                      {{shipper.name}} pour un montant de {{ getShippingPrice(shipper) | formatPrice}}€
                    </label>
                  </div>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="depots.length">
              <tr>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="gobclick-container me-2">
                      <i class="fa-solid fa-shop fa-xl"></i><span>Gob'click & collect</span>
                    </div>
                    <div>
                      <p>Retrait en boutique</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="shipper">
                  <div class="form-check">
                    <input (change)="setClickCollect(cc.checked)" class="form-check-input me-1" type="radio" name="shipper" id="shipper-cc" #cc>
                    <label class="form-check-label" for="shipper-cc">
                      Retrait gratuit dans l'une de nos boutiques
                    </label>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

		<!-- Map -->
		<div id="relay-map-mr" [ngClass]="{hidden: order.shipper!='mondial-relay'}"></div>
		<div id="relay-map-colissimo" [ngClass]="{hidden: order.shipper!='colissimo-relay'}"></div>
		<input id="relay-point" type="hidden" (change)="setRelayID()" value="" name="relaypoint" #relaypoint/>

		<!-- Click & collect -->
		<div *ngIf="depotSelected" class="cc-container">
			<div class="row">
        <!-- Shops for collection -->
        <div class="col-5">
          <div class="list-group">
            <a (click)="setDepot(i)" *ngFor="let depot of depots; first as isFirst; index as i" class="list-group-item list-group-item-action" [ngClass]="{active: (depotSelected.ident==depot.ident)}">
              <b>{{depot.name}}</b><br/>
                <span *ngIf="address && depotSelected.ident==depot.ident" class="mb-1">
                {{address?.address}}<br/>
                {{address?.cp}}, {{address?.city}}
                </span>
            </a>
          </div>
        </div>

        <!-- Days for collection -->
        <div class="col-7">
          <div class="form-floating mb-3">
            <select (change)="setDate(dateSelect.value)" class="form-select" name="hour" id="d-cc" #dateSelect>
              <option>Jour du retrait</option>
              <option *ngFor="let date of datesSelected; index as i" value="{{i}}">{{ date.date | date:'d, MMMM yyyy':'':'fr' }} de {{date.start | slice:0:2}}h à {{date.end | slice:0:2}}h</option>
            </select>
            <label for="d-cc">Jour</label>
          </div>

          <!-- Hours for collection -->
          <div class="form-floating mb-3">
            <select class="form-select" id="h-cc" name="hour" [(ngModel)]="order.hCollect">
              <option [ngValue]="null">Heure du retrait</option>
              <option *ngFor="let hour of hoursSelected" value="{{hour}}">{{hour | slice:0:2}}h{{hour | slice:3:5}}</option>
            </select>
            <label for="h-cc">Heure</label>
          </div>
        </div>
      </div>
		</div>

		<div class="next">
			<button scrollTo type="button" (click)="next()" class="next btn green" [disabled]="!canNext()">Valider</button>
		</div>
	</div>
</div>
